import React, { Fragment, useEffect, useState } from "react";

import { Icon, PlainButton, Thumbnail } from "@culturehq/components";

import { useProfile } from "app/context";
import { Trans, t } from "app/utils";

import { TimeDiff } from "components/common/Time";
import LinkedinComment from "components/linkedin/LinkedinComment";
import LinkedinReaction from "components/linkedin/LinkedinReaction";
import LinkedinSelectedReactions from "components/linkedin/LinkedinSelectedReactions";
import LinkedinReactionText from "components/linkedin/LinkedinReactionText";

const InlineDot = () => (
  <span className="dot">
    <Icon icon="record" />
  </span>
);

const CommentView = ({ comment, onReplyClick, onReacted, parentCommentUrn, linkedinShare }) => {
  const { profile } = useProfile();
  const [myReaction, setMyReaction] = useState();

  useEffect(
    () => {
      const myReactions = comment.reactions?.filter(reaction => reaction.created.actor === `urn:li:person:${profile.userLinkedin.linkedinId}`);
      if (myReactions?.length > 0) {
        setMyReaction(myReactions[0]);
      } else {
        setMyReaction(undefined);
      }
    }, [comment.reactions, profile.userLinkedin.linkedinId]
  );

  return (
    <>
      <div className="comment-body">
        <div className="comment-author">
          {comment["actor~"].id !== "private" ? (
            <>
              {comment["actor~"].profilePicture ? (
                <Thumbnail
                  image={comment["actor~"].profilePicture["displayImage~"]?.elements[0]?.identifiers[0]?.identifier || ""}
                  title={`${comment["actor~"].localizedFirstName} ${comment["actor~"].localizedLastName}`}
                />
              ) : (
                <Thumbnail image="/account.svg" title={t("LinkedIn User")} />
              )}
              {" "}
              {comment["actor~"].localizedFirstName}{" "}{comment["actor~"].localizedLastName}
            </>
          ) : (
            <>
              <Thumbnail image="/account.svg" title={t("LinkedIn User")} />
              {" "}
              <Trans>LinkedIn User</Trans>
            </>
          )}
        </div>
        {" "}
        <span>{comment.message.text}</span>
      </div>
      <div className="comment-options">
        <LinkedinReaction
          onReacted={onReacted}
          commentUrn={parentCommentUrn ? comment.$URN : comment.$URN}
          myReaction={myReaction}
          linkedinShare={linkedinShare}
        >
          <span className="Linkedin-Reactions__Btn-Text"><LinkedinReactionText reaction={myReaction} /></span>
          {comment?.reactions?.length > 0 && (
            <LinkedinSelectedReactions reactions={comment.reactions} />
          )}
        </LinkedinReaction>
        <InlineDot />
        <PlainButton className="reply-link no-select" onClick={onReplyClick}>
          <Trans>Reply</Trans>
        </PlainButton>
        <InlineDot />
        <span className="date no-select">
          <TimeDiff time={comment.lastModified.time} format="%b %e, %Y, %l:%M %p" />
        </span>
      </div>
    </>
  );
};

const SocialComment = ({ comment, onPostSocialComment, onReacted, linkedinShare }) => {
  const [replyingTo, onReplyClick] = useState(null);

  const onSubmitComment = (newComment, parentComment) => {
    onReplyClick(null);
    onPostSocialComment(newComment, parentComment);
  };

  return (
    <div className="CommentListItem">
      <div className="CommentListItem__column">
        <CommentView
          comment={comment}
          onReplyClick={() => onReplyClick(comment.id)}
          onReacted={onReacted}
          linkedinShare={linkedinShare}
        />
      </div>
      {replyingTo === comment.id && (
        <LinkedinComment comment={comment} onPostSocialComment={onSubmitComment} />
      )}
      {comment.childComments?.sort((firstEl, secondEl) => {
        if (firstEl.created.time < secondEl.created.time) {
          return -1;
        }

        if (firstEl.created.time > secondEl.created.time) {
          return 1;
        }

        return 0;
      })?.map(childComment => (
        <Fragment key={childComment.id}>
          <div className="CommentListItem__column comment-child">
            <div className="reply">
              <Icon icon="reply" />
            </div>
            <CommentView
              comment={childComment}
              onReplyClick={() => onReplyClick(childComment.id)}
              onReacted={onReacted}
              parentCommentUrn={comment.$URN}
              linkedinShare={linkedinShare}
            />
          </div>
          {replyingTo === childComment.id && (
            <LinkedinComment comment={comment} onPostSocialComment={onSubmitComment} />
          )}
        </Fragment>
      ))}
    </div>
  );
};

export default SocialComment;
